import styled from "styled-components";
import locationIcon from "../../../../assets/Mayo/Location.svg";
import xIcon from "../../../../assets/Mayo/exit_icon.svg";
import calendarIcon from "../../../../assets/Mayo/Calendar.svg"
import { usePatientFacing } from "../../../../flow/patientFacing/hooks/usePatientFacing";


const getDateString = (date) => {
  return new Date(date).toLocaleDateString("en-US", {
    weekday: "short",
    month: "long",
    day: "numeric",
    year: "numeric",
    // hour: "2-digit",
    // minute: "2-digit",
  });
};

const APPOINTMENTS_DATA = {
  surgery: {
    type: "TAVR",
    title: "Transcatheter Aortic Valve Replacement procedure",
    location: "Saint Marys Campus",
  },
  preSurgery: {
    type: "Angiogram",
    title: "A Coronary Angiogram procedure",
    location: "Saint Marys Campus",
  },
}

function Appointment({type, title, time, location}) {
  return (
    <AppointmentContainer>
      <Title style={{marginBottom: 10}}>
        {type}
      </Title>
      <Text>
        {title}
      </Text>
      <Text style={{marginBottom: 12}}>
        {time}
      </Text>
      <LocationWrapper>
        <Icon src={locationIcon} />
        <Text style={{marginTop: 5}}>
          {location}
        </Text>
      </LocationWrapper>
    </AppointmentContainer>
  );
}

export default function AppointmentsPopUp({onCancle}) {
  const { getEventDataLocal } = usePatientFacing();
  const event = getEventDataLocal();
  const { surgery , preSurgery } = event?.Case?.CardiologyCase || {};

  const appointments = [];
  if(preSurgery) {
    appointments.push({
      ...APPOINTMENTS_DATA.preSurgery,
      time: getDateString(preSurgery)
    })
  }
  if(surgery) {
    appointments.push({
      ...APPOINTMENTS_DATA.surgery,
      time: getDateString(surgery)
    })
  }

  return (
    <>
    <Background onClick={onCancle}/>
    <Container>
      <XIcon src={xIcon} onClick={onCancle}/>
      <Image src={calendarIcon}/>
      <AppointmentsList>
        { appointments.map(appointment =>
          <Appointment 
          {...appointment}
          />
        )}
      </AppointmentsList>
    </Container>
    </>
  );
}

const Background = styled.div`
  position: fixed;
  z-index: 998;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: #1A1A1A;
  opacity: 75%;
`

const Container = styled.div`
  position: fixed;
  z-index: 999;
  overflow-y: auto;
  background-color: #FFFFFF;
  border-radius: 15px;
  border: 1px solid #707070;
  
  padding-left: 31px;
  padding-right: 16px;
  padding-top: 24px;
  padding-bottom: 41px;
  margin-inline: 7.5vw;
  margin-block: 7.5vh;
  width: calc(85vw - 47px);
  max-height: calc(85vh - 65px);
`

const AppointmentsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`

const XIcon = styled.img`
  display: block;
  margin-left: auto;
  margin-right: 8px;
  width: 18px;
  height: 17px;
`

const Image = styled.img`
  display: block;
  margin-bottom: 36px;
  width: 106px;
  height: 106px;
`

const AppointmentContainer = styled.div``

const Title = styled.p`
  margin: 0;
  font-weight: 600;
  font-size: 22px;
  color: #1A1A1A;
`

const Text = styled.p`
  margin: 0;
  font-size: 19px;
  color: #000000;
`

const LocationWrapper = styled.div`
  display : flex;
  gap: 13px;
`

const Icon = styled.img`
  width: 21px;
  height: 31px;
`
